import { useState } from "react";
import "./UserStatistics.css";
import DropDownVersionOne from "./dropDownVersionOne/DropDownVersionOne";

const days = ["1399", "yesterday"];

const yValues = [1000, 750, 500, 250];

const data = [
    {
        name: "1399",
        values: [
            {
                name: "اسفند",
                value: 180,
                energy: 420,
            },
            {
                name: "بهمن",
                value: 260,
                energy: 560,
            },
            {
                name: "دی",
                value: 151,
                energy: 490,
            },
            {
                name: "آذر",
                value: 151,
                energy: 490,
            },
            {
                name: "آبان",
                value: 151,
                energy: 490,
            },
            {
                name: "مهر",
                value: 151,
                energy: 490,
            },
            {
                name: "شهریور",
                value: 151,
                energy: 490,
            },
            {
                name: "مرداد",
                value: 151,
                energy: 490,
            },
            {
                name: "تیر",
                value: 151,
                energy: 490,
            },
            {
                name: "خرداد",
                value: 151,
                energy: 490,
            },
            {
                name: "اردیبهشت",
                value: 151,
                energy: 490,
            },
            {
                name: "فروردین",
                value: 151,
                energy: 490,
            },
        ],
    },
    {
        name: "yesterday",
        values: [
            {
                name: "Protein",
                value: 250,
                energy: 503,
            },
            {
                name: "Fat",
                value: 150,
                energy: 450,
            },
            {
                name: "Carbs",
                value: 240,
                energy: 652,
            },
        ],
    },
];


export default function UserStatistics({ title }) {

    const [day, setDay] = useState("1399");

    const activeData = data.find((d) => d.name === day);

    const handleDayChanged = (nextDay) => setDay(nextDay);

    return(
        <>
            <div className="card-5">
                <div className="card-5-header">
                    <DropDownVersionOne items={days} selectedItem={day} onSelect={handleDayChanged} />
                    <h2>{title}</h2>
                </div>
                <div className="card-5-chart">
                    <div className="card-5-chart-y-axis">
                        {yValues.map((v) => (
                            <label>{v}</label>
                        ))}
                    </div>
                    <div className="card-5-chart-bars">
                        {activeData.values.map((v) => (
                            <div className="card-5-chart-bar-wrapper">
                                <div
                                    className="card-5-chart-bar"
                                    style={{ height: `${v.value / 1.675}px` }}
                                ></div>
                                <label>{v.name}</label>
                                <div className="card-5-chart-tooltip">
                                    <h3>Energy</h3>
                                    <var>{v.energy} kcal</var>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};